// extracted by mini-css-extract-plugin
export default {"img":"AdvantageItem_img__9Q8W7","title":"AdvantageItem_title__lFNKW","text":"AdvantageItem_text__xZ0DP"};